export enum GenereClienteType {
  'Sig'= 'Sig',
  'Sig.ra'= 'Sig.ra',
  'Società'= 'Società'
}
